/* eslint-disable */
export default {
  confirmation: 'Conferma',
  confirmMergeToConference: 'Aggiungere alla conferenza telefonica?',
  mergeToConference: 'Unisci',
  conferenceCall: 'Conferenza telefonica',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
